<template>
  <div>
    <header class="flex justify-between p-3 w-full bg-white z-50" :class="{ 'fixed xl:relative': isShowMenu }">
      <router-link :to="{ name: 'Index' }" class="px-4 md:px-0">
        <img class="object-contain" src="@/assets/image/logo.png" alt="AI英語學習教室">
      </router-link>
      <div class="hidden xl:flex items-center login-blue1-text">
        <router-link :to="{ name: 'Index' }" class="inline-block p-1 cursor-pointer" :class="{ 'border-b-2 login-blue1-border font-bold': $route.name === 'Index' }" @click="isIndex = true">首頁</router-link>
        <router-link :to="{ name: 'Records' }" class="inline-block p-1 cursor-pointer" :class="{ 'border-b-2 login-blue1-border font-bold': $route.name === 'Records' }" @click="isIndex = false">使用紀錄</router-link>
      </div>
      <div class="items-center font-black hidden xl:flex">
        <p class="p-2" v-if="user && user.email">{{ user.email }}</p>
        <div class="flex items-center mx-2 login-purple-text">
          <div><img class="block h-auto mx-auto object-contain mr-1" src="@/assets/image/gept/star.png" alt=""></div>
          <p><span class="text-sm">{{ remainPoints }}</span>點</p>
        </div>
        <a class="inline-block p-2 cursor-pointer" @click="logout2()" v-if="!ai_sid && !ai_uuid">登出</a>
      </div>
      <div class="ham-outer xl:hidden">
        <svg class="ham hamRotate ham1" :class="{ 'active': isShowMenu }" viewBox="0 0 100 100" width="80" @click="isShowMenu = !isShowMenu">
          <path class="line top" d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40" />
          <path class="line middle" d="m 30,50 h 40" />
          <path class="line bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40" />
        </svg>
      </div>
    </header>
    <div class="w-full Sidebar-outer fixed z-50 xl:hidden" v-if="isShowMenu">
      <aside class="sidenav bg-black w-full max-w-full sidebar flex flex-col justify-between">
        <ul class="sidenav__list text-white list-none p-0 text-xl font-semibold">
          <li class="sidenav__list_item text-center text-white font-light" :class="{ 'font-black border-b-2': $route.name === 'Index' }">
            <router-link :to="{ name: 'Index' }" @click.native="isShowMenu = false" class="m-0 flex items-center p-3 px-5 cursor-pointer text-center justify-center">
              首頁
            </router-link>
          </li>
          <li class="sidenav__list_item text-center text-white font-light" :class="{ 'font-black border-b-2': $route.name === 'Records' }">
            <router-link :to="{ name: 'Records' }" @click.native="isShowMenu = false" class="m-0 flex items-center p-3 px-5 cursor-pointer text-center justify-center">
              紀錄
            </router-link>
          </li>
        </ul>
        <ul class="sidenav__list text-white list-none p-0 font-semibold user-bg">
          <li class="sidenav__list_item p-3 px-5 text-center">
            <p class="text-white mb-2" v-if="user && user.email">{{ user.email }}</p>
            <div class="flex items-center login-purple-text justify-center">
              <div><img class="block h-auto mx-auto object-contain mr-1" src="@/assets/image/gept/star.png" alt=""></div>
              <p><span class="text-sm">{{ remainPoints }}</span>點</p>
            </div>
          </li>
          <li class="p-3 px-5">
            <a class="bg-white login-blue1-text p-2 px-3 xl:hidden text-sm cursor-pointer block text-center rounded" @click.prevent="logout2()">登出</a>
          </li>
        </ul>
      </aside>
    </div>
    <div class="flex">
      <div class="contain-main gept_main_bg3 flex-1 p-2 xl:p-6">
        <router-view class="view_contain"></router-view>
      </div>
    </div>
    <footer class="py-10">
      <p class="text-sm font-semibold text-white text-center">Copyright © 2024 Hebron Soft Limited All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Layout',
    components: {
    },

    data () {
      return {
        menuData: null,
        isShowMenu: false
      }
    },

    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'ai_sid',
        'ai_uuid',
        'user'
      ])
    },
    watch: {
    },
    mounted () {
      if (this.ai_sid || this.ai_uuid) {
        this.logout2()
      }
    },
    methods: {
      logout2 () {
        this.$store.dispatch('logout')
        this.$router.replace({ name: 'login' })
      }
    }
  }
</script>
<style lang="scss" scoped>
.user-bg {
  background: linear-gradient(113.68deg, #102A8A 6.89%, #0E618F 98%);
}
.contain-main {
  min-height: calc(100vh - 65px);
}
.Sidebar-outer {
  top: 74px;
  height: calc(100vh - 65px);
  overflow-y: scroll;
  .sidebar {
    height: 100%;
  }
  @media (max-width: 425px) {
    top: 64px;
    height: calc(100vh - 64px);
  }

  @media (max-width: 375px) {
    top: 59px;
    height: calc(100vh - 59px);
  }
  @media (max-width: 320px) {
    top: 53px;
    height: calc(100vh - 53px);
  }
}
.ham-outer {
  width: 50px;
  height: 50px;
  align-items: center;
  display: flex;
  height: 100%;
  overflow: hidden;
}
.ham {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.hamRotate.active {
  transform: rotate(45deg);
}
.hamRotate180.active {
  transform: rotate(180deg);
}
.line {
  fill:none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke:#000;
  stroke-width:5.5;
  stroke-linecap:round;
}
.ham1 .top {
  stroke-dasharray: 40 139;
}
.ham1 .bottom {
  stroke-dasharray: 40 180;
}
.ham1.active .top {
  stroke-dashoffset: -98px;
}
.ham1.active .bottom {
  stroke-dashoffset: -138px;
}
.sidenav {
  width: 100%;
  max-width: 200px;
  .sidenav__list {
    .sidenav__list_item {
      color: #4496C2;
      .hover_on {
        display: none;
      }
      &:hover {
        background: #91D3F6;
        color: #073E5C;
        .hover_on {
          display: block;
        }
        .hover_off {
          display: none !important;
        }
      }
    }
    .active {
      background: #91D3F6;
      color: #073E5C;
      .hover_on {
        display: block;
      }
      .hover_off {
        display: none !important;
      }
    }
  }
}
footer {
  background: linear-gradient(113.68deg, #102A8A 6.89%, #0E618F 98%);
}
</style>